import { createBrowserRouter, Navigate } from 'react-router-dom';
import { PublicLayout, AdminLayout } from '@/components/layout';
import { ProtectedRoute } from '@/features/auth';

// Public pages
import {
  HomePage,
  ServicesPage,
  ServiceDetailPage,
  BlogPage,
  BlogPostPage,
  CaseStudiesPage,
  CaseStudyDetailPage,
  AboutPage,
  ContactPage,
  PrivacyPolicyPage,
  TermsPage,
  NotFoundPage,
} from './public';

// Admin pages
import {
  LoginPage,
  DashboardPage,
  PagesAdminPage,
  ServicesAdminPage,
  BlogAdminPage,
  CaseStudiesAdminPage,
  TestimonialsAdminPage,
  LeadsPage,
  MediaPage,
  SettingsPage,
  ProfilePage,
} from './admin';

export const router = createBrowserRouter([
  // Public routes
  {
    path: '/',
    element: <PublicLayout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'services', element: <ServicesPage /> },
      { path: 'services/:slug', element: <ServiceDetailPage /> },
      { path: 'blog', element: <BlogPage /> },
      { path: 'blog/:slug', element: <BlogPostPage /> },
      { path: 'case-studies', element: <CaseStudiesPage /> },
      { path: 'case-studies/:slug', element: <CaseStudyDetailPage /> },
      { path: 'about', element: <AboutPage /> },
      { path: 'contact', element: <ContactPage /> },
      { path: 'pricing', element: <ServicesPage /> }, // Redirect to services for now
      { path: 'privacy-policy', element: <PrivacyPolicyPage /> },
      { path: 'terms', element: <TermsPage /> },
    ],
  },

  // Admin login (outside protected routes)
  {
    path: '/admin/login',
    element: <LoginPage />,
  },

  // Admin routes (protected)
  {
    path: '/admin',
    element: (
      <ProtectedRoute>
        <AdminLayout />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <Navigate to="/admin/dashboard" replace /> },
      { path: 'dashboard', element: <DashboardPage /> },
      { path: 'pages', element: <PagesAdminPage /> },
      { path: 'services', element: <ServicesAdminPage /> },
      { path: 'blog', element: <BlogAdminPage /> },
      { path: 'case-studies', element: <CaseStudiesAdminPage /> },
      { path: 'testimonials', element: <TestimonialsAdminPage /> },
      { path: 'leads', element: <LeadsPage /> },
      { path: 'media', element: <MediaPage /> },
      { path: 'settings', element: <SettingsPage /> },
      { path: 'profile', element: <ProfilePage /> },
    ],
  },

  // 404 catch-all
  {
    path: '*',
    element: <PublicLayout />,
    children: [{ path: '*', element: <NotFoundPage /> }],
  },
]);
